export default {
    Printer: "Printer",
	Scanner: "Scanner",
	Other: "Other",
	Paper: "Paper",
}